import React from 'react';

import {Skeleton} from '@albert-io/atomic';

/**
 * A ghost classwork row: icon badge + name/subtitle bars, matching the real row's layout and height
 * (40px badge; two text lines → 61px row) so the reveal fills the skeleton in place with no shift.
 * Shared by the assignments and skill-paths lists.
 */
export const SkeletonRow = () => (
  <div className='gap-x2 p-x1 flex items-center'>
    <Skeleton className='h-x5 w-x5 shrink-0 rounded-full' />
    <div className='flex min-w-0 grow flex-col'>
      <div className='h-x3 flex items-center'>
        <Skeleton className='h-x2 w-[35%] rounded-full' />
      </div>
      <div className='h-x2-half flex items-center'>
        <Skeleton className='h-x1-half w-[22%] rounded-full' />
      </div>
    </div>
  </div>
);

interface Props {
  /** Screen-reader status text, e.g. "Loading assignments…". */
  label: string;
  /** Number of ghost rows to render. Default 6. */
  count?: number;
}

/**
 * Rows-only placeholder for the in-list loading state (search / filter refetch), where the heading
 * and controls already stay mounted — so a search shows skeleton rows, not a collapsing spinner.
 */
export const ListRowsSkeleton = ({label, count = 6}: Props) => (
  <div aria-busy='true' className='flex flex-col'>
    <span className='sr-only' role='status'>
      {label}
    </span>
    {Array.from({length: count}, (_v, index) => (
      <SkeletonRow key={index} />
    ))}
  </div>
);
